import AccessDiskBlank from 'assets/hero/access_disk_blank.png';
import { useScreenSizeRatio } from 'hooks/useScreenSizeRatio';
import React, { useEffect, useRef, useState } from 'react';
import styled, { keyframes } from 'styled-components/macro';

const imageWidth = 355;
const imageHeight = 371;

const slideDownAnim = keyframes`
    0%{
        transform: translateY(-${imageHeight}px);
    }
    100%{
        transform: translateY(0px);
    }
`;

const Wrapper = styled.div<{ sizeRatio: number; isGenerating: boolean }>`
  z-index: 3;
  position: absolute;
  top: ${({ sizeRatio }) => `${sizeRatio * 525}px`};
  left: ${({ sizeRatio }) => `calc(50% - ${sizeRatio * 186}px)`};
  width: ${({ sizeRatio }) => `${sizeRatio * imageWidth}px`};
  height: ${({ sizeRatio }) => `${sizeRatio * imageHeight}px`};
  cursor: ${({ isGenerating }) => (!isGenerating ? `pointer` : 'default')};

  overflow: hidden;

  transform: scale(1);
  transition: transform 0.4s ease-in-out;
  &:hover {
    transform: ${({ isGenerating }) => (!isGenerating ? `scale(1.1)` : 'scale(1)')};
  }

  canvas {
    animation: ${slideDownAnim} 3s linear;
  }
`;
const HiddenImg = styled.img`
  display: none;
`;

const AccessDisk: React.FC<{ text: string; isGenerating: boolean }> = ({ text, isGenerating }) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const imgRef = useRef<HTMLImageElement | null>(null);

  const sizeRatio = useScreenSizeRatio();

  const [imgLoaded, setImgLoaded] = useState(false);

  useEffect(() => {
    if (canvasRef?.current && imgRef?.current) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      const img = imgRef.current;

      console.log(sizeRatio);

      if (ctx && imgLoaded) {
        ctx.clearRect(0, 0, imageWidth * sizeRatio, imageHeight * sizeRatio);
        ctx.drawImage(img, 0, 0, imageWidth * sizeRatio, imageHeight * sizeRatio);
        ctx.font = `bold ${14 * sizeRatio}px Presicav`;
        ctx.fillText(text, 55 * sizeRatio, 230 * sizeRatio);
        // resizeTo(canvas, sizeRatio);
      }
    }
  }, [text, sizeRatio, imgLoaded]);

  return (
    <Wrapper
      isGenerating={isGenerating}
      sizeRatio={sizeRatio}
      onClick={() => {
        if (canvasRef?.current) {
          const link = document.createElement('a');
          link.download = 'access_disk.png';
          link.href = canvasRef.current.toDataURL();
          link.click();
        }
      }}
    >
      <canvas ref={canvasRef} width={imageWidth * sizeRatio} height={imageHeight * sizeRatio} />
      <HiddenImg
        onLoad={() => setImgLoaded(true)}
        ref={imgRef}
        src={AccessDiskBlank}
        width={imageWidth}
        height={imageHeight}
      />
    </Wrapper>
  );
};

export default AccessDisk;
